export default __webpack_public_path__ + "locales/ar-SA/DataReassignmentDialog.json?hash=9c9cb854892dee91a8a72045b0ca18d9";